/**
 * Parse INR (rupees) from user input into minor units (paise) for the wallet transfer API.
 * @param {string} raw
 * @param {{ allowZero?: boolean }} opts
 */
export function parseInrMajorToMinor(raw, { allowZero = false } = {}) {
  let s = String(raw).trim().replace(/,/g, '');
  if (s === '') return { ok: false, message: 'Enter an amount in INR.' };
  if (/^\.\d/.test(s)) s = `0${s}`;
  if (!/^\d+(\.\d{0,2})?$/.test(s)) {
    return { ok: false, message: 'Enter a valid INR amount (up to two decimal places).' };
  }
  const dot = s.indexOf('.');
  const intPart = dot === -1 ? s : s.slice(0, dot);
  const frac = dot === -1 ? '00' : `${s.slice(dot + 1)}00`.slice(0, 2);
  const minor = Number(intPart) * 100 + Number(frac);
  if (!Number.isSafeInteger(minor) || minor < 0) {
    return { ok: false, message: 'Amount is too large or invalid.' };
  }
  if (!allowZero && minor < 1) {
    return { ok: false, message: 'Amount must be greater than zero.' };
  }
  return { ok: true, value: minor };
}

/**
 * Extract destination wallet id from QR contents: app URL with `to=`, plain UUID, or opaque id.
 * @param {string} raw
 * @returns {string|null}
 */
export function parseWalletIdFromQrText(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return null;

  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s);
      const to = u.searchParams.get('to')?.trim();
      if (to) return to;
    } catch {
      /* ignore */
    }
  }

  const uuid =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (uuid.test(s)) return s;

  if (/^[A-Za-z0-9_-]{8,128}$/.test(s)) return s;

  return null;
}
